import { BackTop, Spin } from 'antd';
import React, { useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useQuickBuyOrder from '../../Hooks/useQuickBuyOrder';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import { useScrollTop } from '../../Hooks/useScrollTop';
import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import Header from '../../components/Header';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';
import PropertyAbout from '../../components/PropertyAbout/PropertyAbout';
import PropertyBasic from '../../components/PropertyBasic/PropertyBasic';
import PropertyBuyCard from '../../components/PropertyBuyCard/PropertyBuyCard';
import PropertyFaq from '../../components/PropertyFaq/PropertyFaq';
import PropertyHeader from '../../components/PropertyHeader/PropertyHeader';
import PropertyManage from '../../components/PropertyManage/PropertyManage';
import PropertyMarket from '../../components/PropertyMarket/PropertyMarket';
import PropertyNav from '../../components/PropertyNav/PropertyNav';
import PropertyOffering from '../../components/PropertyOffering/PropertyOffering';
import PropertyPerformance from '../../components/PropertyPerformance/PropertyPerformance';
import PropertySlider from '../../components/PropertySlider/PropertySlider';
import PropertyTradeCard from '../../components/PropertyTradeCard/PropertyTradeCard';
import QuickBuyInitial from '../../components/QuickBuyInitialOffering/QuickBuyInitial';
import QuickBuyInitialDrawer from '../../components/QuickBuyInitialOffering/QuickBuyInitialDrawer';
import { getAccountBalances } from '../../services/InitialOfferings/initialOfferingSection';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import { fetchPropertyDetailsAction } from '../../store/reducer/propertyDetailSlice';
import { PROPERTY_SUB_TYPE, PROPERTY_TYPES } from '../../utils/constant';
import { toastNotify } from '../../utils/toastNotify';
import { getUsPercentageFormat } from '../../utils/usCurrencyFormatter';
import { labelData, marketData, offeringData } from './IOVacationData';
import './PropertyListing.scss';
import { tradeData } from './SMVacationData';
import TradeDrawer from './TradeDrawer';
import TradeModal from './TradeModal';

const OBJ = {
  userPurchasedShares: 0,
  id: '',
  name: '',
  investors: 0,
  sharesRemaining: 0,
  perSharePrice: '',
  minimum: '',
  duration: '',
  percentageFunded: 0,
  sharesPurchased: 0,
  totalShares: 0,
  city: '',
  state: '',
  propertyType: '',
  images: {},
  label: '',
};

const SEONDARYOBJ = {
  propertyId: 0,
  propertyName: '',
  label: '',
  cityName: '',
  cityId: 0,
  stateId: 0,
  stateName: '',
  propertyCreatedAt: '',
  images: {},
  propertyType: '',
  dividendYield: 0.0,
  lastTradedPrice: 0,
  allTime: 0.0,
  bids: 0,
  asks: 0,
  likedByLoggedInUser: null,
};
const IOVacation = () => {
  const [openQuickBuy, setOpenQuickBuy] = useState('');
  const [openQuickBuySecondary, setOpenQuickBuySecondary] = useState('');
  const [isFetchingUserAccount, setIsFetchingUserAccount] = useState(false);
  const [userBalance, setUserBalance] = useState(null);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [isSellOpen, setIsSellOpen] = useState('1');
  const userProfileData = useSelector((state) => state.userData.userData);
  const userData = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const formRef = useRef();
  const state = useSelector((state) => state.propertyDetails);
  const { data } = state;
  const quickBuyData = useMemo(() => {
    return {
      ...OBJ,
      userPurchasedShares: Number(data?.data?.userPurchaseDetail?.noOfShares) || 0,
      id: data?.data?.propertyId,
      name: data?.data?.name,
      investors: data?.data?.noOfInvestors || 0,
      sharesRemaining: data?.data?.sharesRemaining,
      perSharePrice: Number(data?.data?.finance?.perSharePrice) || 0,
      minimum: Number(data?.data?.minimumPrice),
      sharesPurchased: data?.data?.sharesPurchased,
      totalShares: Number(data?.data?.totalShare),
      city: data?.data?.city,
      state: data?.data?.state,
      propertyType: data?.data?.propertyTypeName,
      images: data?.data?.images,
      label: data?.data?.tag,
      duration: data?.data?.duration,
    };
  }, [data?.data]);

  const quickBuySecondaryData = useMemo(() => {
    return {
      ...SEONDARYOBJ,
      propertyId: data?.data?.propertyId,
      propertyName: data?.data?.name,
      label: data?.data?.tag,
      cityName: data?.data?.city,
      cityId: 0,
      stateId: 0,
      stateName: data?.data?.state,
      propertyCreatedAt: '',
      images: data?.data?.images,
      propertyType: data?.data?.propertyTypeName,
      dividendYield: data?.data?.tenantStatus?.dividendYield,
      lastTradedPrice: Number(data?.data?.lastPrice),
      allTime: getUsPercentageFormat(
        (100 * (Number(data?.data?.lastPrice) - Number(data?.data?.finance?.perSharePrice))) / Number(data?.data?.finance?.perSharePrice) || 0
      ),
      bids: data?.data?.totalBids,
      asks: data?.data?.totalAsks,
      likedByLoggedInUser: null,
    };
  });
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const { ref, isTop, isScrolledUp } = useScrollTop(150);
  const { propertyType } = useParams();
  const navigate = useNavigate();
  const navigateToHome = () => {
    navigate('/');
  };
  const quickByOptions = useQuickBuyOrder(setOpenQuickBuy, quickBuyData);
  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuySecondary, quickBuySecondaryData, data);

  const onBuyClick = async () => {
    if (Object.keys(userData?.userData).length > 0) {
      if (userData?.userData?.isKYCVerified) {
        try {
          setIsFetchingUserAccount(true);
          setOpenQuickBuy('StepOne');
        } catch (error) {
          const { response } = error;
          toastNotify('error', response?.message || 'Something went wrong');
        } finally {
          setIsFetchingUserAccount(false);
        }
      } else {
        !userData?.userData?.isKYCVerified
          ? toastNotify('error', 'Please complete your kyc aml verification first.')
          : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.');
      }
    } else {
      navigate('/login');
    }
  };

  const onTradeClick = async () => {
    try {
      setIsFetchingUserAccount(true);
      const userData = await getAccountBalances();
      if (!userData.isError) {
        setUserBalance(userData?.data);
        setOpenQuickBuySecondary('StepOne');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.message || 'Something went wrong');
    } finally {
      setIsFetchingUserAccount(false);
    }
  };

  const handleNotifyMe = async (value) => {
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
              propertyId: value?.id,
              forSecondary: value?.isSecondary,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
          : {
              propertyId: storeNotifyMeData?.id,
              forSecondary: storeNotifyMeData?.isSecondary,
              signUpForNewsletter: newsLetterChecked,
              email: value.email,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
      )
    );
  };
  return (
    <div className='iovacation property-listing'>
      {screenMD ? (
        <div className={isScrolledUp ? 'nav-property sticky-nav' : 'nav-property'}>
          <AccountNav navigateToHome={navigateToHome} />
        </div>
      ) : (
        <div className={isScrolledUp ? 'nav-property sticky-nav' : 'nav-property'}>
          <AccountNavMobile navigateToHome={navigateToHome} />
        </div>
      )}
      {screenMD ? (
        <>
          <QuickBuyInitial
            quickByOptions={quickByOptions}
            quickBuyPropertyData={{ ...quickBuyData }}
            open={openQuickBuy}
            modalState={setOpenQuickBuy}
            userBalance={userBalance}
            featchData={() => {
              dispatch(
                fetchPropertyDetailsAction({
                  id: data?.data?.propertyId,
                })
              );
            }}
          />
          <TradeModal
            quickBuySecondaryOptions={quickBuySecondaryOptions}
            open={openQuickBuySecondary}
            modalState={setOpenQuickBuySecondary}
            quickBuyPropertyData={quickBuySecondaryData}
            isSingleTab={false}
            isSell={isSellOpen}
            propertyDetailData={data}
            featchData={() => {
              dispatch(
                fetchPropertyDetailsAction({
                  id: data?.data?.propertyId,
                })
              );
              setOpenQuickBuySecondary('');
            }}
          />
        </>
      ) : (
        <>
          <QuickBuyInitialDrawer
            quickByOptions={quickByOptions}
            quickBuyPropertyData={{ ...quickBuyData }}
            open={openQuickBuy}
            modalState={setOpenQuickBuy}
            userBalance={userBalance}
            featchData={() => {
              dispatch(
                fetchPropertyDetailsAction({
                  id: data?.data?.propertyId,
                })
              );
            }}
          />
          <TradeDrawer
            quickBuySecondaryOptions={quickBuySecondaryOptions}
            open={openQuickBuySecondary}
            modalState={setOpenQuickBuySecondary}
            quickBuyPropertyData={quickBuySecondaryData}
            isSingleTab={false}
            isSell={isSellOpen}
            propertyDetailData={data}
            featchData={() => {
              dispatch(
                fetchPropertyDetailsAction({
                  id: data?.data?.propertyId,
                })
              );
              setOpenQuickBuySecondary('');
            }}
          />
        </>
      )}
      <Header
        url={window.location.href}
        description={state?.data?.data?.propertyDesc || ''}
        title={state?.data?.data?.name || ''}
        image={state?.data?.data?.images?.[state?.data?.data?.images?.primaryImage] || ''}
      />
      {isTop && (
        <PropertyNav
          onBuyClick={onBuyClick}
          onTradeClick={onTradeClick}
          isFetchingUserAccount={isFetchingUserAccount}
          onNotifyClick={(value) => {
            Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
          }}
        />
      )}
      <Spin spinning={state.loading} wrapperClassName={state.loading && 'ant-spin--fullscreen'} className={state.loading && 'ant-spin--fullscreen'}>
        <PropertyHeader />
        <PropertySlider {...labelData} />
        <div className='property-summary container-fluid property-container'>
          <div className='left'>
            <PropertyBasic
              onBuyClick={onBuyClick}
              onTradeClick={onTradeClick}
              isFetchingUserAccount={isFetchingUserAccount}
              onNotifyClick={(value) => {
                Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
              }}
            />
            <div id='about' ref={ref}>
              <PropertyAbout />
            </div>
            <div id={data?.data?.propertyTypeName?.toLowerCase() === PROPERTY_SUB_TYPE.VACATION.toLowerCase() ? 'management' : 'tenant-status'}>
              <PropertyManage />
            </div>
            <div id='market'>
              <PropertyMarket {...marketData} />
            </div>
            <div id='performance'>
              <PropertyPerformance />
            </div>
            <div id='offering'>
              <PropertyOffering {...offeringData} />
            </div>
            <div id='faq'>
              <PropertyFaq />
            </div>
          </div>
          {screenMD && (
            <div className='right'>
              {propertyType === PROPERTY_TYPES.SECONDARY ? (
                <PropertyTradeCard
                  onNotifyClick={(value) => {
                    Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                  }}
                  setIsSellOpen={setIsSellOpen}
                  clickAction={onTradeClick}
                  {...tradeData}
                />
              ) : (
                <PropertyBuyCard
                  onNotifyClick={(value) => {
                    Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                  }}
                  onBuyClick={onBuyClick}
                  isFetchingUserAccount={isFetchingUserAccount}
                />
              )}
            </div>
          )}
        </div>
        <BackTop />
        <MarketFooter />
      </Spin>
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
    </div>
  );
};

export default IOVacation;
